var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDownloadLoading,
          expression: "showDownloadLoading",
        },
      ],
      staticClass: "download-loading",
    },
    [
      _c("div", { staticClass: "download-loading__content" }, [
        _c(
          "div",
          { staticClass: "download-loading__lottie" },
          [
            _c("LottieAnimation", {
              attrs: {
                animationData: require("@/assets/lottie/download.json"),
                loop: true,
                autoPlay: true,
                speed: 1,
              },
            }),
          ],
          1
        ),
        _c("p", { staticClass: "download-loading__text" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.showDownloadLoadingText ||
                  "資料處理中，請不要離開此畫面，感謝您的耐心等候。"
              ) +
              " "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }